import type { FeatureRoute } from '../types';
import { CatalogSetupPage } from './CatalogSetupPage';
import { ProductDetailPage } from './ProductDetailPage';
import { ProductFormPage } from './ProductFormPage';
import { ProductListPage } from './ProductListPage';
import { BomFormPage } from './BomFormPage';
import { BomListPage } from './BomListPage';

/** Routes owned by this feature (paths are relative to the app root, e.g. 'customers/:id'). */
export const routes: FeatureRoute[] = [
  { path: 'products', element: <ProductListPage /> },
  { path: 'products/new', element: <ProductFormPage /> },
  { path: 'products/setup', element: <CatalogSetupPage /> },
  { path: 'products/:id', element: <ProductDetailPage /> },
  { path: 'bom', element: <BomListPage /> },
  { path: 'bom/new', element: <BomFormPage /> },
  { path: 'bom/:productId/:variantId', element: <BomFormPage /> },
];
